<!-- SIDE PANEL -->
@if (!layoutConfig.layout.sidepanel.hidden && layoutConfig.layout.sidepanel.position === 'left') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<div id="main">

  <!-- TOOLBAR: Above fixed -->
  @if (layoutConfig.layout.toolbar.position === 'above-fixed') {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above fixed -->

  <div id="container-1" class="container" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

    <!-- TOOLBAR: Above static -->
    @if (layoutConfig.layout.toolbar.position === 'above-static') {
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    }
    <!-- / TOOLBAR: Above static -->

    <div id="container-2" class="container">

      <!-- NAVBAR: Left -->
      @if (layoutConfig.layout.navbar?.position === 'left') {
        <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
      }
      <!-- / NAVBAR: Left -->

      <!-- CONTENT -->
      <content
        [ngClass]="{'ml-32':layoutConfig.layout.navbar?.position === 'left', 'mr-32':layoutConfig.layout.navbar?.position === 'right'}">
      </content>
      <!-- / CONTENT -->

      <!-- NAVBAR: Right -->
      @if (layoutConfig.layout.navbar?.position === 'right') {
        <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
      }
      <!-- / NAVBAR: Right -->

    </div>

    <!-- FOOTER: Above static -->
    @if (layoutConfig.layout.footer.position === 'above-static') {
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    }
    <!-- FOOTER: Above static -->

  </div>

  <!-- FOOTER: Above fixed -->
  @if (layoutConfig.layout.footer.position === 'above-fixed') {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above fixed -->

</div>

<!-- SIDE PANEL -->
@if (!layoutConfig.layout.sidepanel.hidden && layoutConfig.layout.sidepanel.position === 'right') {
  <!-- PANEL CONTENT -->
}
<!-- / SIDE PANEL -->

<!-- QUICK PANEL -->
<fuse-sidebar name="quickPanel" position="right" class="quick-panel">
  <quick-panel></quick-panel>
</fuse-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (!layoutConfig.layout.toolbar.hidden) {
    <toolbar
    [ngClass]="[layoutConfig.layout.toolbar.position, layoutConfig.layout.toolbar.background]"></toolbar>
  }
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!layoutConfig.layout.footer.hidden) {
    <footer
    [ngClass]="[layoutConfig.layout.footer.position, layoutConfig.layout.footer.background]"></footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!layoutConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" class="navbar-fuse-sidebar"
      [folded]="layoutConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="layoutConfig.layout.navbar.variant"
      class="left-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  @if (!layoutConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar"
      [folded]="layoutConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="layoutConfig.layout.navbar.variant"
      class="right-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / RIGHT NAVBAR -->